import { useConfig } from '@/hooks/useConfig/useConfig';
import { ThreeDS } from '@/templates/3DS/3DS';
import { AntiVishing } from '@/templates/AntiVishing/AntiVishing';
import { ErrorScreen_DEPRECIATED } from '@components/ErrorScreen/ErrorScreen_DEPRECIATED';

function getTemplate(template: string) {
  switch (template) {
    case 'AntiVishing':
      return <AntiVishing />;
    case '3DS':
      return <ThreeDS />;
    default:
      return (
        <ErrorScreen_DEPRECIATED
          title={`Template "${template}" not found.`}
          body="Please check your configuration."
        />
      );
  }
}

export function Template() {
  const { template } = useConfig();

  return getTemplate(template);
}
